export default __webpack_public_path__ + "static/web-dev-card-01-258bf269befb510736a28c9324c44e1e.svg";